import React, { useEffect, useRef } from 'react';

/**
 * Card component represents a card in the product pricing section.
 *
 * @component
 * @param {Object} props - The props object containing the card properties.
 * @param {string} props.id - The id of the card.
 * @param {string} props.className - The class name for the card.
 * @param {string} props.cardId - The card id.
 * @returns {JSX.Element} The Card component.
 */
const Card = (props) => {
	const cardRef = useRef(null);

	useEffect(() => {
		// Scroll to card if hash matches card id
		if (window.location.hash === `#${props.id}`) {
			window.scrollTo(0, cardRef.current.offsetTop);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div ref={cardRef} id={props.id} className={`prc__card ${props.className}`} data-cardid={props.cardId}>
			{props.children}
		</div>
	);
};

export default Card;
